import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase/app'
import store from '../store'
import PathNotFound from '../views/pathNotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    name: 'Login',
    path: '/login',
    component: () => import('../views/login.vue')
  },
  {
    name: 'SignInWithToken',
    path: '/signInWithToken',
    component: () => import('../views/signInWithToken.vue')
  },
  {
    name: 'Home',
    path: '/',
    component: () => import('../views/home.vue'),
  },
  {
    name: 'Feature',
    path: '/feature',
    component: () => import('../views/feature.vue'),
  },
  {
    name: 'Package',
    path: '/package',
    component: () => import('../views/package.vue'),
  },
  {
    name: 'Contact',
    path: '/contact',
    component: () => import('../views/contact.vue'),
  },
  {
    name: 'PrivacyPolicy',
    path: '/privacy-policy',
    component: () => import('../views/privacy-policy.vue'),
  },
  {
    name: 'Register',
    path: '/register',
    component: () => import('../views/register.vue'),
  },
  {
    name: 'Forgotpassword',
    path: '/forgot-password',
    component: () => import('../views/forgotPassword.vue'),
  },
  {
    name: 'ConnectionError',
    path: '/connection-error',
    component: () => import('../views/connection-error.vue'),
  },
  {
    name: 'SelectCompany',
    path: '/companies-list',
    component: () => import('../views/company/list.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'AddCompany',
    path: '/company-add',
    component: () => import('../views/company/add.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'AddCompanyWithRegisterCode',
    path: '/company-add-with-code',
    component: () => import('../views/company/add-with-register-code.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'TaxInfoNeeded',
    path: '/tax-info-needed/:linkId',
    component: () => import('../views/tax-info-needed.vue'),
  },
  {
    name: 'OAuthCallback',
    path: '/oauth/google-drive/callback',
    component: () => import('../views/oauth-callback.vue'),
  },
  {
    name: 'DaemonLink',
    path: '/daemon/link',
    component: () => import('../views/daemon/link.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'DaemonPair',
    path: '/daemon/pair/:workerId',
    component: () => import('../views/daemon/pair.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'DaemonManage',
    path: '/daemon/manage',
    component: () => import('../views/daemon/manage.vue'),
    meta: { requiresAuth: true }
  },
  {
    name: 'Company',
    path: '/:companyId',
    component: () => import('../views/company/index.vue'),
    children: [
      {
        name: 'Company.Dashboard',
        path: 'dashboard',
        component: () => import('../views/company/dashboard.vue'),
        meta: { requiresAuth: true }
      },
      {
        // Standalone "company is suspended" page (no Admin chrome). Reached via
        // the beforeEach gate when a suspended AP/AR company is entered.
        name: 'Company.Suspended',
        path: 'suspended',
        component: () => import('../views/company/company-suspended.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Documents',
        path: 'documents',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.UploadHistory',
        path: 'upload-history',
        component: () => import('../views/UploadHistory.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.DocumentsSaleOnline',
        path: 'documents-sale',
        component: () => import('../views/company/documents.saleorders.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.DocumentsRDB',
        path: 'documents-rdb',
        component: () => import('../views/company/documents.rdb.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.DocumentsApproved',
        path: 'documents-approved',
        component: () => import('../views/company/documents.approved.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.DocumentsPurchase',
        path: 'documents-purchase',
        component: () => import('../views/company/documents.purchase.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.TX',
        path: 'documents-tx',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.DR',
        path: 'documents-dr',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.CR',
        path: 'documents-cr',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.RE',
        path: 'documents-re',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.AB',
        path: 'documents-ab',
        component: () => import('../views/company/documents.abb.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.RT',
        path: 'documents-rt',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.CL',
        path: 'documents-cl',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Documents.Invoice',
        path: 'documents/invoice',
        component: () => import('../views/company/documents.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings',
        path: 'settings',
        component: () => import('../views/company/settings.vue'),
        meta: { requiresAuth: true },
      },
      {
        name: 'Company.Settings.AddAccountingYear',
        path: 'settings/add-accounting-year',
        component: () => import('../views/company/setting-add-accounting-year.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Board',
        path: 'settings/board',
        component: () => import('../views/company/setting-board.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Users',
        path: 'settings/users',
        component: () => import('../views/company/setting-users.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Email',
        path: 'settings/email',
        component: () => import('../views/company/setting-email.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Exchange',
        path: 'settings/exchange',
        component: () => import('../views/company/setting-exchange.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ExchangeRepair',
        path: 'settings/exchange-repair',
        component: () => import('../views/company/setting-exchange-repair.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.AutoDoc',
        path: 'autodoc',
        component: () => import('../views/company/setting-auto-doc.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ApAutomation',
        path: 'settings/ap-automation',
        component: () => import('../views/company/setting-ap.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ApAutomationMaster',
        path: 'settings/ap-automation-master',
        component: () => import('../views/company/setting-ap-master.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ApAutomationPrompt',
        path: 'settings/ap-automation-prompt',
        component: () => import('../views/company/setting-ap-prompt.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.ApAutomationPromptStudent',
        path: 'settings/ap-automation-prompt-student',
        component: () => import('../views/company/setting-ap-prompt-student.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Packages',
        path: 'settings/packages',
        component: () => import('../views/company/setting-packages.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.PlanManagement',
        path: 'settings/plan-management',
        component: () => import('../views/company/setting-plan-management.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Payments',
        path: 'settings/payments',
        component: () => import('../views/company/setting-payments.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Keys',
        path: 'settings/keys',
        component: () => import('../views/company/setting-keys.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Erp',
        path: 'settings/erp',
        component: () => import('../views/company/setting-erp.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Company',
        path: 'settings/company',
        component: () => import('../views/company/setting-company.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.CompanyDetail',
        path: 'settings/company/:companyDetailId',
        component: () => import('../views/company/setting-company-detail.vue'),
        meta: { requiresAuth: true }
      },

      {
        name: 'Company.Settings.Shops.Add',
        path: 'settings/shops/add',
        component: () => import('../views/company/shop/shop.add.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Shops',
        path: 'settings/shops/:shopId?',
        component: () => import('../views/company/shop/shop.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Shops.Channels',
        path: 'settings/shops/:shopId/channels/:channelId',
        component: () => import('../views/company/shop/shop.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Shops.Edit',
        path: 'settings/shops/:shopId/edit',
        component: () => import('../views/company/shop/shop.edit.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Branch',
        path: 'settings/branch',
        component: () => import('../views/company/setting-branch.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Wht',
        path: 'settings/wht',
        component: () => import('../views/company/setting-wht.vue'),
        meta: { requiresAuth: true }
      },
      {
      name: 'Company.Settings.TestDoc',
      path: 'settings/testdoc',
      component: () => import('../views/company/setting-testdoc.vue'),
      meta: { requiresAuth: true },
      },
      {
      name: 'Company.Settings.TestDoc-AP',
      path: 'settings/testdoc-ap',
      component: () => import('../views/company/setting-testdoc-ap.vue'),
      meta: { requiresAuth: true },
      },
      {
      name: 'Company.Settings.CreateDuplicateCompany',
      path: 'settings/create-duplicate-company',
      component: () => import('../views/company/setting-create-duplicate-company.vue'),
      meta: { requiresAuth: true },
      },
      {
      name: 'Company.Settings.CreateDuplicateCompanyConfig',
      path: 'settings/create-duplicate-company-config',
      component: () => import('../views/company/setting-create-duplicate-company-config.vue'),
      meta: { requiresAuth: true },
      },
      {
        name: 'Company.Settings.KBank',
        path: 'settings/kbank',
        component: () => import('@/views/company/setting-kbank.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.API',
        path: 'settings/api',
        component: () => import('@/views/company/setting-api.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Products',
        path: 'settings/products',
        component: () => import('@/views/company/setting-products.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.LaoEtax',
        path: 'settings/lao-etax',
        component: () => import('@/views/company/setting-lao-etax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.Department',
        path: 'settings/department',
        component: () => import('../views/company/setting-dep.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Profile',
        path: 'profile',
        component: () => import('../views/profile.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Downloaded',
        path: 'downloaded',
        component: () => import('../views/company/downloaded.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Report',
        path: 'report',
        component: () => import('../views/company/report.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Laboratory',
        path: 'laboratory',
        component: () => import('../views/company/laboratory.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.SelectPackage',
        path: 'package',
        component: () => import('../views/company/select.package.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.BuyCertification',
        path: 'buy-certification',
        component: () => import('../views/company/buy.certification.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Payment',
        path: 'payment',
        component: () => import('../views/company/payment.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.FileTracking',
        path: 'filetracking',
        component: () => import('../views/company/fileTracking.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.reportDocumentAI',
        path: 'reportDocumentAI',
        component: () => import('../views/company/reportDocumentAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentPOAI',
        path: 'documentpoai',
        component: () => import('../views/company/documentPOAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentPOAIVendor',
        path: 'DocumentPOAIVendor/:vendorId',
        component: () => import('../views/company/documentPOAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentSOAI',
        path: 'documentsoai',
        component: () => import('../views/company/documentSOAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentSOAIVendor',
        path: 'DocumentSOAIVendor/:vendorId',
        component: () => import('../views/company/documentSOAI.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.ExchangeRate',
        path: 'exchangerate',
        component: () => import('../views/company/exchangeRate.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.ExchangeHistory',
        path: 'exchangehistory',
        component: () => import('../views/company/exchangeRateHistory.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentTOPSERV',
        path: 'documentTopserv',
        component: () => import('../views/company/documentTOPSERV.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.DocumentTOPSERVBranch',
        path: 'DocumentTOPSERV/:endsWith',
        component: () => import('../views/company/documentTOPSERV.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.WithholdingTax',
        path: 'reportnetsuitethaitax-withholdingtax',
        component: () => import('../views/company/documents.withholdingTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.ReportNetsuiteThaiTax',
        path: 'reportnetsuitethaitax',
        component: () => import('../views/company/reportNetsuiteThaiTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.WithholdingIncomTax',
        path: 'reportnetsuitethaitax-withholdingIncomTax',
        component: () => import('../views/company/withholdingIncomTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.WithholdingIncomTax.Cancel',
        path: 'reportnetsuitethaitax-withholdingIncomTax-cancel',
        component: () => import('../views/company/documents.withholdingTax.vue'),
        meta: { requiresAuth: true }
      },
      // ภาษี มูลค่าเพี่ม
      {
        name: 'Company.ReportThaiTax',
        path: 'ReportThaiTax',
        component: () => import('../views/company/ReportThaiTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.TaxSales',
        path: 'ReportThaiTax-taxSales',
        component: () => import('../views/company/documents.valueAddedTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.TaxBuy',
        path: 'ReportThaiTax-taxBuy',
        component: () => import('../views/company/documents.valueAddedTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.TaxBuyAverage',
        path: 'ReportThaiTax-taxBuyAverage',
        component: () => import('../views/company/documents.valueAddedTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.taxSupplementaryReport',
        path: 'ReportThaiTax-taxSupplementaryReport',
        component: () => import('../views/company/taxSupplementaryReport.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.TaxSupplementaryReportPP36',
        path: 'ReportThaiTax-taxSupplementaryReportPP36',
        component: () => import('../views/company/taxSupplementaryReportPP36.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.TaxReport',
        path: 'ReportThaiTax-taxReport',
        component: () => import('../views/company/taxReport.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.CancelValueAddedTax',
        path: 'ReportThaiTax-CancelTax',
        component: () => import('../views/company/documents.valueAddedTax.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.CancelValueAddedTaxPP36',
        path: 'ReportThaiTax-CancelTaxPP36',
        component: () => import('../views/company/documents.valueAddedTaxPP36.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.CancelValueAddedTaxPP54',
        path: 'ReportThaiTax-CancelTaxPP54',
        component: () => import('../views/company/documents.valueAddedTaxPP54.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayable',
        path: 'accountspayable',
        component: () => import('../views/company/documents.accountspayable.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableFileAuto',
        path: 'accountspayable-fileauto',
        component: () => import('../views/company/documents.accountspayableFileAuto.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableForeign',
        path: 'accountspayable-foreign',
        component: () => import('../views/company/documents.accountspayable.foreign.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableForeignSuccess',
        path: 'accountspayable-foreign-success',
        component: () => import('../views/company/documents.accountspayable.foreign.success.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableSuccess',
        path: 'accountspayable-success',
        component: () => import('../views/company/documents.accountspayable.success.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableReject',
        path: 'accountspayable-reject',
        component: () => import('../views/company/documents.accountspayable.reject.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableAuditAutomation',
        path: 'accountspayable-auditautomation',
        component: () => import('../views/company/documents.accountspayable.auditautomation.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayablePND123',
        path: 'accountspayable-PND123',
        component: () => import('../views/company/documents.accountspayable.PND123.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayablePND50to55',
        path: 'accountspayable-PND50to55',
        component: () => import('../views/company/documents.accountspayable.PND50to55.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableUpload',
        path: 'accountspayable-upload',
        component: () => import('../views/company/documents.accountspayable.upload.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayablePending',
        path: 'accountspayable-pending',
        component: () => import('../views/company/documents.accountspayable.pending.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableNoneVat',
        path: 'accountspayable-none-vat',
        component: () => import('../views/company/documents.accountspayable.pending.vue'),
        meta: { requiresAuth: true, noneVatOnly: true }
      },
      {
        name: 'Company.AccountsPayableStudent',
        path: 'accountspayablestudent',
        component: () => import('../views/company/documents.accountspayable.student.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.RevenueDepartmentPnd1to3',
        path: 'revenuedepartment-pnd1to3',
        component: () => import('../views/company/documents.revenuedepartment.pnd1to3.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.RevenueDepartmentPnd50to55',
        path: 'revenuedepartment-pnd50to55',
        component: () => import('../views/company/documents.revenuedepartment.pnd50to55.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.RevenueDepartmentPp303640',
        path: 'revenuedepartment-pp303640',
        component: () => import('../views/company/documents.revenuedepartment.pp303640.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.RevenueDepartmentSuccess',
        path: 'revenuedepartment-success',
        component: () => import('../views/company/documents.revenuedepartment.success.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableDelete',
        path: 'accountspayable-delete',
        component: () => import('../views/company/documents.accountspayable.delete.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableAnalytics',
        path: 'acctsanalytics',
        component: () => import('../views/company/documents.acctsanalytics.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.AccountsPayableTaxReport',
        path: 'acctstaxreport',
        component: () => import('../views/company/documents.acctstaxreport.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.LoadingFileLog',
        path: 'loadingfilelog',
        component: () => import('../views/company/documents.loadingfilelog.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Settings.DispCompanies',
        path: 'settings/dispcompanies',
        component: () => import('../views/company/setting-display-companies.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.FixedAsset',
        path: 'fixed-asset',
        component: () => import('../views/company/fixedAsset.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.FixedAssetsList',
        path: 'fixed-assets-list',
        component: () => import('../views/company/fixedAssetsList.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.FixedAssetCount',
        path: 'fixed-assets-count',
        component: () => import('../views/company/fixedAssetsCount.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'fixedAssetsCountDetail',
        path: 'session-count/:countId',
        component: () => import('../views/company/fixedAssetsCountDetail.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Documents.PND54',
        path: 'pnd54',
        component: () => import('../views/company/documents.pnd54.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Documents.PP36',
        path: 'pp36',
        component: () => import('../views/company/documents.pp36.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.Documents.PP36NTST',
        path: 'pp36ntst',
        component: () => import('../views/company/documents.pp36NTST.vue'),
        meta: { requiresAuth: true }
      },
      {
        name: 'Company.CancelPP36NTST',
        path: 'pp36ntst-CancelTaxPP36',
        component: () => import('../views/company/documents.pp36NTST.vue'),
        meta: { requiresAuth: true }
      },
       // end ภาษี มูลค่าเพี่ม
      { path: '/:pathMatch(.*)*', component: PathNotFound },
    ],
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser
  if (requiresAuth && !currentUser) {
    // Preserve the requested URL as ?redirect=<path> so deep-link flows
    // (e.g. /daemon/link?port=19385 from the etax-foxpro CLI) come back to
    // the original page after sign-in. auth.js resolvePostLoginPath reads
    // this and bounces back. Skip when the destination is the root or the
    // login page itself to avoid loops.
    const fullPath = to.fullPath
    if (fullPath && fullPath !== '/' && !fullPath.startsWith('/login')) {
      next({ path: '/login', query: { redirect: fullPath } })
    } else {
      next('/login')
    }
    return
  }

  // Let the page render immediately. The suspension / lab-licence gate runs in
  // the background (afterEach below) instead of awaiting a Firestore read on
  // every reload, so normal companies are never delayed. A blocked company is
  // bounced to the suspended page once the check resolves. This is a billing
  // lock, not a security boundary — firestore.rules enforce actual data access —
  // so a brief render of a blocked company's own workspace before the redirect
  // is acceptable.
  next()
})

// Background suspension / lab-licence gate. Runs after the navigation is
// confirmed so it never blocks first paint. Only fires when entering/switching
// a company (not on in-company navigation), fails open on a transient error,
// and re-checks the current route before redirecting so a fast onward
// navigation isn't clobbered.
router.afterEach((to, from) => {
  const currentUser = firebase.auth().currentUser
  const companyId = to.params.companyId
  const entersCompany = to.matched.some(x => x.name === 'Company')
  const enteringNewCompany = companyId && from.params.companyId !== companyId
  // Also re-check when moving from the suspended page into a real page of the
  // same company (e.g. a manually typed URL) so the block can't be side-stepped.
  const leavingSuspendedPage = from.name === 'Company.Suspended'
  if (
    !currentUser ||
    !entersCompany ||
    !(enteringNewCompany || leavingSuspendedPage) ||
    to.name === 'Company.Suspended'
  ) {
    return
  }
  store
    .dispatch('companies/isCompanyAccessBlocked', { companyId })
    .then((blocked) => {
      if (
        blocked &&
        router.currentRoute.params.companyId === companyId &&
        router.currentRoute.name !== 'Company.Suspended'
      ) {
        router.replace({ name: 'Company.Suspended', params: { companyId } })
      }
    })
    .catch(() => {
      // fail open — never lock out an active company on a transient error
    })
})


export default router
